import { create } from 'zustand'
import { Api } from '~/@api/generated-api-types/global.types'
import { useAuthStore } from './authStore'

export interface AuthSecurityData {
  token: string
}

export class ApiClient {
  apiInstance: Api<AuthSecurityData>

  constructor() {
    this.apiInstance = new Api<AuthSecurityData>({
      baseUrl: import.meta.env.VITE_REACT_API_HOST,
      baseApiParams: {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
      },
      securityWorker: (securityData: AuthSecurityData | null) => {
        return securityData && securityData.token
          ? {
              headers: {
                Authorization: `Bearer ${securityData.token}`,
              },
            }
          : {}
      },
    })

    const token = useAuthStore.getState().authToken
    if (token) {
      this.apiInstance.setSecurityData({ token })
    }
  }

  setAuthToken(newToken: string) {
    useAuthStore.getState().setAuthToken(newToken)
    this.apiInstance.setSecurityData({ token: newToken })
  }

  removeAuthToken() {
    useAuthStore.getState().removeAuthToken()
    this.apiInstance.setSecurityData(null)
  }

  updateTokenFromStore() {
    const token = useAuthStore.getState().authToken
    if (token) {
      this.apiInstance.setSecurityData({ token })
    } else {
      this.apiInstance.setSecurityData(null)
    }
  }
}

interface ApiClientState {
  apiClient: ApiClient
}

export const useApiClientStore = create<ApiClientState>(() => ({
  apiClient: new ApiClient(),
}))
